<p-dialog
  header="{{ isEditMode ? 'Edit Dispatch Trip' : 'Create Dispatch Trip' }}"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '800px' }"
  [closable]="true"
  (onHide)="close()"
>
  <div class="dispatch-trip-modal-content" *ngIf="!isLoading">
    <form [formGroup]="tripForm">
      <div class="row">
        <!-- Reference Number -->
        <div class="col-md-4">
          <label>Reference Number <span class="required">*</span></label>
          <input
            type="text"
            class="form-control"
            formControlName="referenceNumber"
            [class.is-invalid]="
              tripForm.get('referenceNumber')?.touched && tripForm.get('referenceNumber')?.invalid
            "
          />
          <small
            *ngIf="
              tripForm.get('referenceNumber')?.touched &&
              tripForm.get('referenceNumber')?.hasError('duplicate')
            "
            class="text-danger"
          >
            This reference number already exists.
          </small>
          <small
            *ngIf="
              tripForm.get('referenceNumber')?.touched &&
              tripForm.get('referenceNumber')?.hasError('required')
            "
            class="text-danger"
          >
            Reference number is required.
          </small>
        </div>

        <!-- Start Date -->
        <div class="col-md-4">
          <label>Start Date</label>
          <p-calendar
            formControlName="startDate"
            [showIcon]="true"
            dateFormat="mm/dd/yy"
            styleClass="w-100"
            appendTo="body"
          ></p-calendar>
        </div>

        <!-- Status -->
        <div class="col-md-4">
          <label>Status</label>
          <p-dropdown
            formControlName="status"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            styleClass="w-100"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>

      <div class="row mt-3">
        <!-- BOL Number -->
        <div class="col-md-4">
          <label>BOL Number</label>
          <input type="text" class="form-control" formControlName="bolNumber" />
        </div>

        <!-- Dispatcher -->
        <div class="col-md-4">
          <label>Dispatcher</label>
          <p-dropdown
            formControlName="dispatcherId"
            [options]="dispatchers"
            optionLabel="name"
            optionValue="id"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            placeholder="Select Dispatcher"
            styleClass="w-100"
            appendTo="body"
          ></p-dropdown>
        </div>

        <!-- Product -->
        <div class="col-md-4">
          <label>Product</label>
          <p-dropdown
            formControlName="productId"
            [options]="products"
            optionLabel="name"
            optionValue="id"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            placeholder="Select Product"
            styleClass="w-100"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>

      <div class="row mt-3">
        <!-- Client -->
        <div class="col-md-6">
          <label>Client</label>
          <p-dropdown
            formControlName="clientId"
            [options]="clients"
            optionLabel="companyName"
            optionValue="id"
            [filter]="true"
            filterBy="companyName"
            [showClear]="true"
            placeholder="Select Client"
            styleClass="w-100"
            (onChange)="onClientChange()"
            appendTo="body"
          ></p-dropdown>
        </div>

        <!-- Bill To -->
        <div class="col-md-6">
          <label>Bill To</label>
          <p-dropdown
            formControlName="billToId"
            [options]="getFilteredBillToClients()"
            optionLabel="companyName"
            optionValue="id"
            [filter]="true"
            filterBy="companyName"
            [showClear]="true"
            placeholder="Select Bill To"
            styleClass="w-100"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>

      <div class="row mt-3">
        <!-- Load Location -->
        <div class="col-md-6">
          <label>Load Location</label>
          <app-location-picker
            [isSelected]="tripForm.get('loadLocationId')?.value"
            [locId]="loadLocationLocId"
            (locationSelected)="onLoadLocationSelected($event)"
            tableId="loadLocationTable"
            searchFieldId="load_location_search"
            buttonId="openLoadLocationBtn"
          ></app-location-picker>
        </div>

        <!-- Unload Location -->
        <div class="col-md-6">
          <label>Unload Location</label>
          <app-location-picker
            [isSelected]="tripForm.get('unloadLocationId')?.value"
            [locId]="unloadLocationLocId"
            (locationSelected)="onUnloadLocationSelected($event)"
            tableId="unloadLocationTable"
            searchFieldId="unload_location_search"
            buttonId="openUnloadLocationBtn"
          ></app-location-picker>
        </div>
      </div>

      <div class="row mt-4">
        <!-- Delivery Window Start -->
        <div class="col-md-6">
          <label>Delivery Window Start</label>
          <p-calendar
            formControlName="deliveryWindowStartDate"
            [showIcon]="true"
            dateFormat="mm/dd/yy"
            styleClass="w-100"
            appendTo="body"
          ></p-calendar>
        </div>

        <!-- Delivery Window End -->
        <div class="col-md-6">
          <label>Delivery Window End</label>
          <p-calendar
            formControlName="deliveryWindowEndDate"
            [showIcon]="true"
            dateFormat="mm/dd/yy"
            styleClass="w-100"
            appendTo="body"
          ></p-calendar>
        </div>
      </div>

      <div class="row mt-3">
        <!-- Driver -->
        <div class="col-md-4">
          <label>Driver</label>
          <p-dropdown
            formControlName="driverId"
            [options]="drivers"
            optionLabel="displayName"
            optionValue="id"
            [filter]="true"
            filterBy="displayName"
            [showClear]="true"
            placeholder="Select Driver"
            styleClass="w-100"
            (onChange)="onDriverChange()"
            appendTo="body"
          ></p-dropdown>
        </div>

        <!-- Tractor -->
        <div class="col-md-4">
          <label>Tractor</label>
          <p-dropdown
            formControlName="tractorId"
            [options]="tractors"
            optionLabel="unitNumber"
            optionValue="id"
            [filter]="true"
            filterBy="unitNumber"
            [showClear]="true"
            placeholder="Select Tractor"
            styleClass="w-100"
            appendTo="body"
          ></p-dropdown>
        </div>

        <!-- Trailer -->
        <div class="col-md-4">
          <label>Trailer</label>
          <p-dropdown
            formControlName="trailerId"
            [options]="trailers"
            optionLabel="trailerNo"
            optionValue="id"
            [filter]="true"
            filterBy="trailerNo"
            [showClear]="true"
            placeholder="Select Trailer"
            styleClass="w-100"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>

      <div class="row mt-3">
        <!-- Driver Notes -->
        <div class="col-md-6">
          <label>Driver Notes</label>
          <textarea
            class="form-control"
            formControlName="driverNotes"
            rows="3"
            placeholder="Notes for the driver..."
          ></textarea>
        </div>

        <!-- Client Notes -->
        <div class="col-md-6">
          <label>Client Notes</label>
          <textarea
            class="form-control"
            formControlName="clientNotes"
            rows="3"
            placeholder="Notes for the client..."
          ></textarea>
        </div>
      </div>

      <!-- Attachments -->
      <div class="row mt-3">
        <div class="col-md-12">
          <label>Attachments</label>
          <div class="file-upload-area">
            <input
              type="file"
              multiple
              (change)="onFileSelected($event)"
              class="form-control-file"
              accept=".jpg,.jpeg,.png,.pdf,.tiff,.tif,.doc,.docx,.xls,.xlsx"
            />
            <small class="text-muted"
              >Accepted: .jpg, .png, .pdf, .tiff, .doc, .docx, .xls, .xlsx</small
            >
          </div>
          <div *ngIf="displayFiles.length > 0" class="attached-files-list mt-2">
            <div *ngFor="let file of displayFiles" class="file-item">
              <span class="file-name">{{ file.originalFileName || file.name }}</span>
              <button
                type="button"
                class="btn btn-sm btn-link text-danger"
                (click)="removeFile(file)"
                title="Remove file"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div class="file-preview mt-2">
            <app-new-mixed-preview-files #mixedPreview [files]="displayFiles">
            </app-new-mixed-preview-files>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="isLoading" class="text-center p-4">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
    <p>Loading...</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex align-items-center">
      <div class="email-actions mr-2 ml-auto" *ngIf="isEditMode">
        <button
          class="btn btn-info mr-2"
          (click)="sendClientEmail()"
          [disabled]="sendingClientEmail || isSaving || isLoading || !emailFeaturesEnabled"
          title="{{
            !emailFeaturesEnabled
              ? 'Email features are disabled'
              : clientEmailSentUtc
                ? 'Last sent: ' + (clientEmailSentUtc | date: 'short')
                : 'Send delivery notification to client'
          }}"
        >
          <i *ngIf="sendingClientEmail" class="fa fa-spinner fa-spin"></i>
          <i *ngIf="!sendingClientEmail && clientEmailSentUtc" class="fa fa-check text-success"></i>
          <i *ngIf="!sendingClientEmail && !clientEmailSentUtc" class="fa fa-envelope"></i>
          Email Client
        </button>
        <button
          class="btn btn-info"
          (click)="sendDriverEmail()"
          [disabled]="sendingDriverEmail || isSaving || isLoading || !emailFeaturesEnabled"
          title="{{
            !emailFeaturesEnabled
              ? 'Email features are disabled'
              : driverEmailSentUtc
                ? 'Last sent: ' + (driverEmailSentUtc | date: 'short')
                : 'Send trip details to driver'
          }}"
        >
          <i *ngIf="sendingDriverEmail" class="fa fa-spinner fa-spin"></i>
          <i *ngIf="!sendingDriverEmail && driverEmailSentUtc" class="fa fa-check text-success"></i>
          <i *ngIf="!sendingDriverEmail && !driverEmailSentUtc" class="fa fa-envelope"></i>
          Email Driver
        </button>
      </div>
      <div>
        <button class="btn btn-secondary" (click)="close()" [disabled]="isSaving">Cancel</button>
        <button class="btn btn-primary ml-2" (click)="save()" [disabled]="isSaving || isLoading">
          <i *ngIf="isSaving" class="fa fa-spinner fa-spin"></i>
          {{ isSaving ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<app-email-compose-modal
  [(visible)]="showEmailCompose"
  [email]="emailComposeData"
  (confirmed)="onEmailComposeConfirmed($event)"
></app-email-compose-modal>
